import axios from 'axios';

import { buildCxApiUrl, CX_API_ENDPOINTS } from '../config/cxApiConfig';

export interface CXReferral {
  accessToken?: string;
  companyName: string;
  createdAt: string;
  friendOfferAmountCents: number;
  referralCode: string;
  referralId: string;
  referredName: string;
  referrerName: string;
  rewardAmountCents: number;
  status: 'invited' | 'opened' | 'claimed' | 'booked' | 'qualified' | 'paid' | 'cancelled';
}

export interface CreateCXReferralInput {
  message: string;
  referredContact: string;
  referredName: string;
  referrerContact: string;
  referrerName: string;
  tenantSlug: string;
}

export async function createCXReferral(input: CreateCXReferralInput): Promise<CXReferral> {
  const response = await axios.post<CXReferral>(
    buildCxApiUrl(CX_API_ENDPOINTS.PUBLIC_REFERRALS),
    input,
  );
  return response.data;
}

export async function getCXReferral(referralCode: string): Promise<CXReferral> {
  const response = await axios.get<CXReferral>(
    buildCxApiUrl(CX_API_ENDPOINTS.PUBLIC_REFERRAL(referralCode)),
  );
  return response.data;
}

export async function getCXReferralAccess(accessToken: string): Promise<CXReferral> {
  const response = await axios.get<CXReferral>(
    buildCxApiUrl(CX_API_ENDPOINTS.PUBLIC_REFERRAL_ACCESS(accessToken)),
  );
  return response.data;
}

export async function claimCXReferral(
  referralCode: string,
  input: { contact: string; contactPreference: string; name: string; serviceNeed: string },
): Promise<CXReferral> {
  const response = await axios.post<CXReferral>(
    buildCxApiUrl(CX_API_ENDPOINTS.PUBLIC_REFERRAL_CLAIM(referralCode)),
    input,
  );
  return response.data;
}
